export function getOrCreateSessionId(): string {
  // Keep it in-memory for lifetime of the pane (per spec).
  // Module-level singleton is enough because the Task Pane is a single-page route.
  if (typeof globalThis !== 'undefined') {
    const anyGlobal = globalThis as any
    if (!anyGlobal.__outlookAddinSessionId) {
      anyGlobal.__outlookAddinSessionId = crypto.randomUUID()
    }
    return anyGlobal.__outlookAddinSessionId as string
  }
  return crypto.randomUUID()
}

